module.exports = __webpack_public_path__ + "static/img/lzsjbT.3c946794.png";